import { render, staticRenderFns } from "./Vimeo.vue?vue&type=template&id=4a27aa0e"
import script from "./Vimeo.vue?vue&type=script&lang=js"
export * from "./Vimeo.vue?vue&type=script&lang=js"
import style0 from "./Vimeo.vue?vue&type=style&index=0&id=4a27aa0e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports